<template>
  <div class="user-modal">
    <form>

      <section class="row">
        <!-- NAME -->
        <div class="row-field">
          <label for="userModalWorkerName" class="input-label">{{ 'Фирма подизпълнител' }}</label>
          <div class="input-wrapper" :class="{ 'invalid': !isNameValid }">
            <span class="tms">B</span>
            <input id="userModalWorkerName" type="text" :placeholder="'Име на подизпълнителя'" v-model="user.name"
              @keyup="isNameValid = true, formatName()" />
          </div>
        </div>
      </section>

      <h1 class="center-text">Добави групи към фирмата подизпълнител</h1>

      <div v-if="workerGroups && workerGroups.length" class="group-inputs-wrapper">
        <section class="row-inputs" v-for="(g, i) of workerGroups" :key="g._id">
          <div class="input-wrapper">
            <span class="tms">B</span>
            <input type="text" :placeholder="'Име на група'" v-model="g.name" />
          </div>
          <div class="input-wrapper">
            <span class="tms">B</span>
            <input type="text" :placeholder="'Брой на хората в групата'" v-model="g.workersCount"
              @keyup="formatWorkersCount(i)" />
          </div>
          <div class="input-wrapper">
            <span class="tms">B</span>
            <input type="text" :placeholder="'Имена на хората в групата (разделени със запетая)'" v-model="g.users"
              @blur="formatGroupMemebers(g)" />
          </div>
          <div class="input-wrapper">
            <span class="tms">B</span>
            <input type="text" :placeholder="$t('coefficient')" v-model="g.coefficient" @keyup="formatWorkersCoefficient(i)"/>
          </div>
          <span class="tms delete" @click="removeWorkerGroup(i)">b</span>
        </section>
      </div>
      <section class="add-wrapper" @click="addWorkerGroup()">
        <span class="tms">t</span>
        <p>Добави група към подизпълнителя</p>
      </section>

      <hr>

      <div class="user-modal-actions">
        <div class="switch-container">
          <label class="switch">
            <input type="checkbox" v-model="user.isActive" @change="changeActiveStateWorkerGroups()"/>
            <span class="slider"></span>
          </label>
          <label v-if="user.isActive">{{ $t('active-single') }}</label>
          <label v-else>{{ $t('inactive-single') }}</label>
        </div>

        <div class="btns">
          <button v-if="!idToEdit" class="btn btn-new" type="submit" value="Submit" @click.prevent="register">
            <!-- <span class="tms">B</span> -->
            {{ $t('save') }}
          </button>
          <button v-else class="btn btn-new" type="submit" value="Submit" @click.prevent="edit">
            <!-- <span class="tms">B</span> -->
            {{ $t('save') }}
          </button>
          <!-- <button class="btn btn-close" @click.prevent="closeModal(false)">
              <span class="tms">F</span>
              {{ $t('cancel') }}
            </button> -->
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '../mixins/log.js';
import axios from 'axios';
export default {
  mixins: [log],
  props: ['idToEdit'],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser'
      // ...
    ]),
  },
  data() {
    return {
      isNameValid: true,
      workerGroups: [],
      user: {
        username: '',
        password: '',
        email: '',
        name: '',
        position: '',
        phone: '',
        company: '',
        coefficient: 1,
        isActive: true,
        group: { _id: '' },
        permissions: {
          isSuperAdmin: false,
          isAdmin: false,
          isReporter: false,
          isWorker: true,
          // isCEO: false,
          // isHR: false,
          // isTechLead: false
        }
      }
    };
  },
  methods: {
    changeActiveStateWorkerGroups() {
      for (let wg of this.workerGroups) {
        wg.isActive = this.user.isActive;
      }
    },
    addWorkerGroup() {
      this.workerGroups.push({})
    },
    removeWorkerGroup(i) {
      if (this.workerGroups[i] && this.workerGroups[i]._id) {
        this.$http
          .delete(
            `${process.env.VUE_APP_BASE_URI}/group/${this.workerGroups[i]._id}`
          )
          .then((res) => {
            if (res.data.errorMsg) {
              this.$snotify.error(res.data.errorMsg);
            } else {
              this.$snotify.success("Промените са записани успешно!");
              this.getWorkerGroups(this.idToEdit)
            }
          })
          .catch((error) => {
            console.log(error.response);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          });
      } else {
        this.workerGroups.splice(i, 1)
      }

    },
    getSpecificUser(id) {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/${id}`)
        .then(response => {
          this.user = response.data;
          if (!this.user.leave) {
            this.user.leave = {};
          }
        });
    },
    // Reformat username - only lowercase latin letters, numbers, dot, underscore and dash
    formatName() {
      this.user.name = this.user.name.replace(/[^А-Яа-я0-9 -._]/g, '');
    },
    formatWorkersCount(i) {
      this.workerGroups[i].workersCount = this.workerGroups[i].workersCount.replace(/\D/g, '')
    },
    formatWorkersCoefficient(i) {
      this.workerGroups[i].coefficient = this.workerGroups[i].coefficient.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1");
    },
    formatGroupMemebers(g) {
      if(g.users.length && typeof g.users === 'string'){
        let wo = g.users.split(',')
        wo = wo.map((w) => w.trim())
        
        g.users = wo.join(',');
      }
    },
    async checkForm() {
      if (!this.user.name) {
        this.isNameValid = false;
         this.$snotify.error("Въведете има на подизпълнителя.");
        return false;
      }

      if(this.user.name) {
        let url = `${process.env.VUE_APP_BASE_URI}/auth/users?name=${this.user.name}`;
        if (this.user._id) {
          url += `&ignoreId=${this.user._id}`;
        }

        let getExistingWorkerGroup = await axios.get(url);

        if(getExistingWorkerGroup.data.length){
         this.$snotify.error("Вече има подизпълнител с такова име.");
        return false;
        }
    }

      if (this.workerGroups.length) {
        for (let wg of this.workerGroups) {
          if (!wg.name) {
            if (wg._id)
              this.$snotify.error(
                "Групи на подизпълнител не може да се трият, заради съществуващи отчитания. Може да преименувате групите, но не и да ги изтривате."
              );
            else this.$snotify.error("Не сте добавили име на група подиз.");
            return false;
          }
          if (!wg.coefficient || isNaN(wg.coefficient)) {
            this.$snotify.error("Не сте добавили коефициент.");
            return false;
          }
        }
      }

      // if not
      return true;
    },
    getWorkerGroups(id) {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group?workerGroups=true&worker=${id}`)
        .then((response) => {
          this.workerGroups = response.data;
          this.$store.dispatch("stopLoading");
        });
    },
    async saveWorkerGroup(userId) {
      const promises = [];
      
      for (let wg of this.workerGroups) {
        let method = 'post';

        if (wg.isActive === undefined) wg.isActive = true
        if (wg.isWorkerGroup === undefined) wg.isWorkerGroup = true
        wg.worker = userId
        if (wg._id) method = 'put'

        promises.push(
          await new Promise((resolve) => {
            this.$http[method](`${process.env.VUE_APP_BASE_URI}/group`, wg)
              .then(() => {
                resolve();
              })
              .catch((err) => {
                this.error = err.response.data.message;
              });
          })
        )

      }

      if (promises.length) {
        Promise.all(promises)
          .then(() => {
            this.closeModal(true);
           })
          .catch((err) => {
            console.log(err.response);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          });
      } else {
          this.closeModal(true);
      }

    },
    async register() {
      if (await this.checkForm()) {
        let userForRequest = this.user;

        this.$http
          .post(`${process.env.VUE_APP_BASE_URI}/auth/register`, userForRequest)
          .then((res) => {
            this.$snotify.success(this.$t('success-new-user'));
            this.saveWorkerGroup(res.data._id)
            this.newLog('newUser', this.user.username);
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error(this.$t('something-went-wrong'));
          })
          .then(() => { });
      } else {
        // TODO: Do something
      }
    },
    async edit() {
      if (await this.checkForm()) {
        this.$http
          .put(
            `${process.env.VUE_APP_BASE_URI}/auth/users/${this.idToEdit}`,
            this.user
          )
          .then(res => {
            this.$snotify.success(this.$t('success-changes'));
            this.saveWorkerGroup(this.user._id)
            this.newLog('editUser', this.user.username);
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error(this.$t('something-went-wrong'));
          })
          .then(() => { });
      } else {
        // TODO: Do something
      }
    },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$emit('closeWorkerModal', { isEdited: isEdited });
    }
  },
  mounted() {
    document.body.classList.add("no-scroll");

    if (this.idToEdit) {
      this.getSpecificUser(this.idToEdit);
      this.getWorkerGroups(this.idToEdit)
    }

    this.$eventBus.$on('closeModalFromSpeechRecognition', () => {
      this.closeModal();
    });
  },
  destroyed() {
    document.body.classList.remove("no-scroll");
    this.$eventBus.$off('closeModalFromSpeechRecognition');
  }
};
</script>